import { DashboardProcessingResultsComponent } from './layout/dashboard/components/dashboard-processing-results/dashboard-processing-results.component';
import { DashboardResidualsOutlookComponent } from './layout/dashboard/components/dashboard-residuals-outlook/dashboard-residuals-outlook.component';
import { DashboardActiveResidualsComponent } from './layout/dashboard/components/dashboard-active-residuals/dashboard-active-residuals.component';
import { CookieService } from 'ngx-cookie-service';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
// import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { AuthInterceptor } from './shared/services/auth.interceptor';
import { NgbModule, NgbDateParserFormatter, NgbModalModule } from '@ng-bootstrap/ng-bootstrap';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { AuthGuard, SharedPipesModule } from './shared';
import { environment } from 'environments/environment';
import { LookupEnvironmentService } from './shared/services/lookup-environment.service';
import { KeepAliveService } from './shared/services/keep-alive.service';
import { NgbdModalContentComponent } from './shared/components/session-timeout-modal/session-timeout-content.component';
import { SessionTimeoutModalComponent } from './shared/components/session-timeout-modal/session-timeout-modal.component';
import { SessionService } from './shared/services/session.service';
import { CoreModule } from './core/core.module';
import { MerchantSearchMediatorService } from './shared/services/mediators/merchant-search-mediator.service';
import { SalesEntityMediatorService } from './shared/services/mediators/sales-entity-search-mediator.service';
import { SecurableGuard } from './shared/guard/secured.route';
import { SalesEntitySelectorModalComponent } from './layout/sales-entity/sales-entity-detail/tabs/setup/modals/SalesEntitySelectorModal/se-selector-content.component';
import { SalesEntityBoardingSelectorModalComponent } from './layout/sales-entity/sales-entity-detail/tabs/setup/modals/BoardingHierarchySelector/se-boarding-content.component';
import { SalesEntityBreabcrumbsModule } from 'app/layout/sales-entity/components/sales-entity-breadcrumbs/sales-entity-breabcrumbs.module';
import { FormatService } from './shared/services/format.service';
import { FormsValidationService } from './shared/services/formsValidation.service';
import { CanDeactivateGuard } from './shared/guard/save.guard';
import { SalesEntityContactEditorComponent } from './layout/sales-entity/sales-entity-detail/tabs/contacts/modals/se-contact-editor';
import { SalesEntityAddressEditorComponent } from './layout/sales-entity/sales-entity-detail/tabs/addresses/modals/se-address-editor';
import { SalesEntityContractEditorComponent } from './layout/sales-entity/sales-entity-detail/tabs/contracts/modals/se-contract-editor';
import { SalesEntityCompPlanTierEditorModalComponent } from './layout/sales-entity/sales-entity-compplans/add-tier-modal/se-tier-editor';
import { PendingDetailLogModalComponent } from './layout/approvals/pending-detail/modals/pending-detail-log.component';
import { SpinnerOverlayModule } from './shared/components/spinner-overlay/spinner-overlay.module';
import { SecurableModule } from './shared/securables/Securable.module';
import { DashboardSubModule } from './layout/dashboard/dashboard.submodule';
import { DashboardComponent } from './layout/dashboard/dashboard.component';
import { TimelineComponent, NotificationComponent, ChatComponent, DashListComponent, ArticleListComponent, DashboardCellComponent, DashboardCellBodyComponent, DashboardKpiComponent } from './layout/dashboard/components';
import { DashboardVolComponent } from './layout/dashboard/components/dashboard-vol/dashboard-vol.component';
import { DashboardAppsComponent } from './layout/dashboard/components/dashboard-apps/dashboard-apps.component';
import { GrowthChartComponent } from './layout/charts/components/growth-chart/growth-chart.component';
import { BoardedMerchantCountsChartComponent } from './layout/charts/components/boarded-merchant-counts-chart/boarded-merchant-counts-chart.component';
import { DashboardGrowComponent } from './layout/dashboard/components/dashboard-growth/dashboard-grow.component';
import { DashboardClosedComponent } from './layout/dashboard/components/dashboard-closed/dashboard-closed.component';
import { DashboardPendAppComponent } from './layout/dashboard/components/dashboard-pend-app/dashboard-pend-app.component';
import { DashboardBoardedComponent } from './layout/dashboard/components/dashboard-boarded/dashboard-boarded.component';
import { AngularMultiSelectModule } from 'angular2-multiselect-dropdown';
import { DragulaModule } from 'ng2-dragula';
import { DashboardTopPerfComponent } from './layout/dashboard/components/dashboard-top-perf/dashboard-top-perf.component';
import { AlertViewComponentModal } from './layout/announcements/detail/modals/alert-view-modal.component';
import { DateUtilityService } from './shared/services/dateUtility.service';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ToastrModule } from 'ngx-toastr';
import { SortableModule } from './shared/directives/sortable.module';
import { ContactVerifyComponent } from './layout/announcements/preferences/tabs/contact/modals/verify/contact-verify.component';
import { ContactEditorComponent } from './layout/announcements/preferences/tabs/contact/modals/contact-editor/contact-editor.component';
import { DeliverySelectorComponent } from './layout/announcements/preferences/tabs/delivery/modals/delivery-selector.component';
import { UtilitiesService } from './shared/services/utilities.service';
import { ResidualOutlookChartComponent } from './layout/dashboard/components/dashboard-residuals-outlook/residual-outlook-chart/residual-outlook-chart.component';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { NoteModalComponent } from './layout/merchant/search/modals/notemodal.component';
import { ControlErrorComponent } from './shared/components/control-error/control-error.component';
import { EvoToastr } from './shared/services/EvoToastr.service';
import { SharedFormatModule } from './shared/formatters/shared-format.module';

@NgModule({
	declarations: [AppComponent,
		NgbdModalContentComponent,
		SalesEntitySelectorModalComponent,
		SalesEntityContactEditorComponent,
		SalesEntityAddressEditorComponent,
		SalesEntityBoardingSelectorModalComponent,
		SalesEntityContractEditorComponent,
		SalesEntityCompPlanTierEditorModalComponent,
		AlertViewComponentModal,
		PendingDetailLogModalComponent,
		ContactVerifyComponent,
		ContactEditorComponent,
		DeliverySelectorComponent,
		NoteModalComponent,
		ControlErrorComponent,
	],
	imports: [
		BrowserModule,
		HttpClientModule,
		BrowserAnimationsModule,
		FormsModule,
		AppRoutingModule,
		ReactiveFormsModule,
		NgbModule,
		NgbModalModule,
		CoreModule.forRoot(),
		ToastrModule.forRoot(),
		SalesEntityBreabcrumbsModule,
		SecurableModule,
		SpinnerOverlayModule,
		DashboardSubModule,
		DragulaModule.forRoot(),
		AngularMultiSelectModule,
		SharedPipesModule,
		SortableModule,
		FontAwesomeModule,
		SharedFormatModule
	],
	providers: [
		AuthGuard,
		SecurableGuard,
		CanDeactivateGuard,
		DateUtilityService,
		CookieService,
		{
			provide: HTTP_INTERCEPTORS,
			useClass: AuthInterceptor,
			multi: true
		},
		LookupEnvironmentService,
		KeepAliveService,
		FormsValidationService,
		SessionTimeoutModalComponent,
		SessionService,
		MerchantSearchMediatorService,
		FormatService,
		EvoToastr,
		SalesEntityMediatorService,
		UtilitiesService,
		{ provide: 'SESSION_STORAGE', useFactory: getSessionStorage }
	],
	exports: [ControlErrorComponent],
	bootstrap: [AppComponent],
	entryComponents: [NgbdModalContentComponent,
		SalesEntitySelectorModalComponent,
		SalesEntityBoardingSelectorModalComponent,
		SalesEntityContactEditorComponent,
		SalesEntityAddressEditorComponent,
		SalesEntityContractEditorComponent,
		SalesEntityCompPlanTierEditorModalComponent,
		AlertViewComponentModal,
		PendingDetailLogModalComponent,
		DashboardComponent,
		TimelineComponent,
		NotificationComponent,
		ChatComponent,
		DashListComponent,
		ArticleListComponent,
		DashboardCellComponent,
		DashboardCellBodyComponent,
		DashboardKpiComponent,
		DashboardVolComponent,
		DashboardAppsComponent,
		GrowthChartComponent,
		BoardedMerchantCountsChartComponent,
		DashboardGrowComponent,
		DashboardClosedComponent,
		DashboardPendAppComponent,
		DashboardBoardedComponent,
		DashboardTopPerfComponent,
		ContactVerifyComponent,
		ContactEditorComponent,
		DeliverySelectorComponent,
		DashboardActiveResidualsComponent,
		DashboardResidualsOutlookComponent,
		ResidualOutlookChartComponent,
		NoteModalComponent,
		DashboardProcessingResultsComponent,
	]
})
export class AppModule { }

export function getSessionStorage() {
	return typeof window !== 'undefined' ? window.sessionStorage : null;
}
